// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from "../../isWithinInterval/index.js";
import convertToFP from "../_lib/convertToFP/index.js";
var isWithinInterval = convertToFP(fn, 2);
export default isWithinInterval;